export const inspectTable = [
  {
    id: 1,
    content: '보호구 지급 및 착용을 하였는가?',
    is_checked: ''
  },
  {
    id: 2,
    content: '벌·해충 등에 대한 약제 및 기피제 등을 지급하였는가?',
    is_checked: ''
  },
  {
    id: 3,
    content: '구급약품 및 용구를 비치하였는가?',
    is_checked: ''
  },
  {
    id: 4,
    content: '어깨높이 이상 기계톱을 사용하고 있지 않는가?',
    is_checked: ''
  },
  {
    id: 5,
    content: '낫 날과 몸체 연결부 고정 상태가 양호한가?',
    is_checked: ''
  },
  {
    id: 6,
    content: '고지톱과 작업자의 각도가 45°를 유지하는가?',
    is_checked: ''
  },
  {
    id: 7,
    content: '고소작업 시 안전대 착용 등 떨어짐 방지조치를 하였는가?',
    is_checked: ''
  },
  {
    id: 8,
    content: '작업자 간 15m 이상의 안전거리를 확보하였는가?',
    is_checked: ''
  },
  {
    id: 9,
    content: '급경사지에서 작업하고 있지 않는가?',
    is_checked: ''
  },
  {
    id: 10,
    content: '고지톱 등을 들고 이동 시 날에 보호덮개를 부착하였는가?',
    is_checked: ''
  },
];
